var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"iv2-loading"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"loader":"dots"},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }